import { gql } from '@/Types/gql';

export const GET_TRAINER_PAYMENT_SUMMARY = gql(`
 query TrainerPaymentHistory($search: String, $filter: JSON, $sort: JSON, $limit: Int, $offset: Int, $trainerPaymentHistoryCountSearch2: String, $trainerPaymentHistoryCountFilter2: JSON) {
  trainerPaymentHistory(search: $search, filter: $filter, sort: $sort, limit: $limit, offset: $offset) {
    _id
    amount
    paidOn
    note
    sessionCount
    traineeName
    trainerName
    trainingType {
      _id
      title
      icon
    }
    transactionId
    trainerId
    trainingTypeId
    sessionUniqId
  }
  trainerPaymentHistoryCount(search: $trainerPaymentHistoryCountSearch2, filter: $trainerPaymentHistoryCountFilter2)
}
`);